export default __webpack_public_path__ + "static/media/c7.48f0f541.png";